import clx from 'classnames'
import { Icon } from '@vzmi/shp_shared_compo'
import styles from './Table.css'
import { numeralFormat } from '../../../../../../lib/renderUtil'
import { pullLeft, pullRight, center } from '../../../../../styles/shared.css'
import { HyperLink } from '../../../../Common/Form'
import RankingTable from '../../../../Common/NewDashboard/Table/RankingTable/RankingTable'
import YPopover from '../../../../Common/Popover'
import { FIELD, FIELD_MAP } from '../constants'

const columns = props => [
  {
    /** 關鍵字 */
    id: FIELD.KEYWORD,
    accessor: FIELD.KEYWORD,
    // width: 337,
    headerClassName: clx(pullLeft, styles.col),
    className: clx(pullLeft),
    Header: FIELD_MAP[FIELD.KEYWORD],
    Cell: row => <p className={styles.keyword}>{row.value}</p>
  },
  {
    /** 點擊量 */
    id: FIELD.CLICKS,
    accessor: FIELD.CLICKS,
    width: 131,
    Header: FIELD_MAP[FIELD.CLICKS],
    headerClassName: clx(pullRight, styles.col),
    className: clx(pullRight, styles.col),
    Cell: row => numeralFormat(row.value, { allowZero: true })
  },
  {
    // 曝光量
    id: FIELD.IMPRESSIONS,
    accessor: FIELD.IMPRESSIONS,
    width: 161,
    Header: () => (
      <YPopover
        placement='top'
        content='曝光在前20筆搜尋結果的次數'
      >
        {`${FIELD_MAP[FIELD.IMPRESSIONS]} `}
        <Icon
          name={'ec-information-fill'}
          size={17}
          align='top'
          color='#979ba7'
        />
      </YPopover>
    ),
    headerClassName: clx(pullRight, styles.col),
    className: clx(pullRight, styles.col),
    Cell: row => numeralFormat(row.value, { allowZero: true })
  },
  {
    id: FIELD.CTR,
    accessor: FIELD.CTR,
    width: 122,
    Header: () => (
      <YPopover
        placement='top'
        content='公式：點擊量/曝光量 (%)'
      >
        {`${FIELD_MAP[FIELD.CTR]} `}
        <Icon
          name={'ec-information-fill'}
          size={17}
          align='top'
          color='#979ba7'
        />
      </YPopover>
    ),
    headerClassName: clx(pullRight, styles.col),
    className: clx(pullRight, styles.col),
    Cell: row => numeralFormat(row.value, { allowZero: true, format: '0.00' })
  },
  {
    id: 'listing-link',
    accessor: FIELD.KEYWORD,
    width: 109,
    Header: '',
    headerClassName: clx(center, styles.col, styles.lastCol),
    className: clx(center, styles.col, styles.lastCol),
    Cell: row => (
      <HyperLink
        data-role='keyword-listings-link'
        onClick={() => props.onListingClick(row.value)}
      >
        檢視賣場
      </HyperLink>
    )
  }
]

const Table = props => {
  return (
    <RankingTable
      sortable={false}
      resizable={false}
      showPagination={false}
      data={props.data}
      columns={columns(props)}
      className={styles.resultTable}
      rankingColumnProps={{
        width: 70,
        Header: '排行'
      }}
      {...props}
    />
  )
}

export default Table
